import React from 'react';
import { Container, ErrorLabel } from './ErrorMessage.styled';

import { Warning } from '@epo/epods-react-components/lib/Icons/Warning';
import { Close } from '@epo/epods-react-components/lib/Icons/Close';

const ErrorMessage = ({ closeMsg, errorMsg }) => {
    return (
        <Container>
            <Warning size="24px" color="#E65100" />
            <ErrorLabel>{errorMsg}</ErrorLabel>
            <Close
                onClick={closeMsg}
                style={{ padding: '2px', boxSizing: 'border-box', cursor: 'pointer' }}
                size="24px"
            />
        </Container>
    );
};

export default ErrorMessage;
